import React,{useRef} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import classes from './BrandCarousel.module.css'
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination,Autoplay} from 'swiper/modules';
import { Link, useNavigate } from 'react-router-dom';


const CategoryCarousel = ({data,category}) => {

    const swiperRef = useRef(null);
    console.log(data)

    const navigate = useNavigate()


    const handleSeeAll=()=>{
      navigate(`/Category/${data[0].category}`)
    }


  return (
    <div className={classes.container}>
    <h2 className='text-yellow-500 font-["Oxanium", cursive] text-3xl font-bold p-2'>{category}</h2>
    <Swiper
      slidesPerView={2}
      spaceBetween={30}
      ref={swiperRef}
      loop={true}
      autoplay={{
        delay: 2000, // Time in milliseconds between slides
        disableOnInteraction: false, // Keeps autoplay running even after interaction
      }}
      spaceBetween={10}
      className="mySwiper"
     
      breakpoints={{
    // Small devices (mobile phones, 640px and down)
        576: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // Medium devices (tablets, 768px and up)
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // Large devices (desktops, 1024px and up)
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        // Extra large devices (1200px and up)
        1200: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      }}
      modules={[Pagination,Autoplay]}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
     

    >
      {
        data?.map((item,idx)=>(
          <SwiperSlide className={classes.slide} key={idx}>
          <div className="relative mb-30 w-[100%]" >
                  <div className="latest-games-thumb h-[15rem] w-[100%] rounded-md ">
                    <a href={item?.game}>
                      <img
                        src={item?.image}
                        alt="Game SRC"
                       
                        className='rounded-lg h-full w-full'
                      />
                    </a>
                  </div>
                  <div className="latest-games-content rounded-lg">
                    <div className="lg-tag">
                      <Link to={`/Category/${item.category}`} onClick={handleSeeAll}>{item.category}</Link>
                    </div>
                    <p>
                      {item.name}
                      {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. */}
                    </p>
                  </div>
                </div>
      </SwiperSlide>
        ))
      }
      
    </Swiper>
    <br/>
    <div className="see-all">
              <button>
                <span className="btn wow fadeInUp" onClick={handleSeeAll}>
                  SEE ALL
                </span>
              </button>
            </div>
    </div>
  )
}

export default CategoryCarousel
